import React, { useRef } from 'react';
import classNames from 'classnames';
import DropDownBox from '../DropDownBox/DropDownBox.js';
import Flag from '../Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import { useClickOutsideElement } from '../../services/hooks/useClickOutsideElement.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import Icon from '../Icon/Icon.js';
import styles from './PhoneSelectButton.module.scss.js';

var PhoneSelectButton = function (_a) {
    var _b, _c;
    var country = _a.country, children = _a.children, menuController = _a.menuController, hasError = _a.hasError;
    var menuExpanded = menuController.menuExpanded, setMenuExpanded = menuController.setMenuExpanded;
    var refNode = useRef(null);
    useClickOutsideElement(refNode, function () { return setMenuExpanded(false); });
    var buttonArrow = menuExpanded ? 'icon-arrow-up' : 'icon-arrow-down';
    return (React.createElement("div", { className: classNames(styles.dropDownButton, menuExpanded && styles.expanded), ref: refNode },
        React.createElement("button", { tabIndex: -1, type: "button", onClick: function () { return setMenuExpanded(!menuExpanded); }, className: classNames(!children && styles.disabled, styles.phoneSelectButton, hasError && styles.error), id: "phoneSelectButton" },
            React.createElement(Flag, { country: (_b = country === null || country === void 0 ? void 0 : country.code) !== null && _b !== void 0 ? _b : '', className: styles.buttonLabel }),
            React.createElement("p", { className: styles.buttonLabel }, (_c = country === null || country === void 0 ? void 0 : country.dialCode) !== null && _c !== void 0 ? _c : ''),
            children && React.createElement(Icon, { icon: buttonArrow, className: styles.buttonArrow, size: "small" })),
        React.createElement(DropDownBox, { className: menuExpanded ? styles.maxheight : '', expanded: menuExpanded }, children)));
};

export { PhoneSelectButton as default };
